import { render, staticRenderFns } from "./Admin2.vue?vue&type=template&id=18e0003c&scoped=true"
import script from "./Admin2.vue?vue&type=script&lang=js"
export * from "./Admin2.vue?vue&type=script&lang=js"
import style0 from "./Admin2.vue?vue&type=style&index=0&id=18e0003c&prod&lang=scss"
import style1 from "./Admin2.vue?vue&type=style&index=1&id=18e0003c&prod&scoped=true&lang=css"
import style2 from "./Admin2.vue?vue&type=style&index=2&id=18e0003c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0003c",
  null
  
)

export default component.exports